import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import PaletteIcon from "@material-ui/icons/Palette";
import EditIcon from '@material-ui/icons/Edit';
import AppsIcon from '@material-ui/icons/Apps';
import SettingsIcon from '@material-ui/icons/Settings';
import InheritageWrapper from "./Inheritage/InheritageWrapper";
import EmailIcon from '@material-ui/icons/Email';
import LabelIcon from '@material-ui/icons/Label';

export const ElementTabGroup = ({ toggle, activeTab, tabName, tempIsInherited = null, email = false }) => {
  return (
    <Nav
      tabs
      style={{
        backgroundColor: "#fff",
        width: "100%",
        marginTop: '-14px',
        maxHeight: "55px"
      }}
    >
      <NavItem
        style={{
          width: "33.333%",
          maxHeight: "55px"
        }}
      >
        <NavLink
          onClick={() => toggle(0, '1')}
          style={{
            padding: "7px",
            width: "100%",
            textAlign: "center",
            maxHeight: "55px",

          }}
          className={activeTab === '1' ? 'jirango-active' : 'jirango-not-active'}
        >
          <EditIcon style={{
            fontSize: "1.2rem",
          }} />
          <div
            style={{
              fontWeight: "600",
              fontSize: "9px",
              marginTop: '2px',
              textTransform: "uppercase",
              borderBottom: "0px !important"
            }}
          >
            <SystemLabel name="ContentSettingsTab" />
          </div>
        </NavLink>
      </NavItem>
      <NavItem
        style={{
          width: "33.333%",
          maxHeight: "55px"
        }}
      >
        <NavLink
          onClick={() => toggle(0, '2')}
          style={{
            padding: "7px",
            width: "100%",
            textAlign: "center",
            maxHeight: "55px",

          }}
          className={activeTab === '2' ? 'jirango-active' : 'jirango-not-active'}
        >
          <PaletteIcon style={{
            fontSize: "1.2rem",
          }} />
          <div
            style={{
              fontWeight: "600",
              fontSize: "9px",
              marginTop: '2px',
              textTransform: "uppercase",
              borderBottom: "0px !important"
            }}
          >
            <SystemLabel name="StyleSettingsTab" />
          </div>
        </NavLink>
      </NavItem>
      <NavItem
        style={{
          width: "33.333%",
          maxHeight: "55px"
        }}
      >
        <NavLink
          style={{ width: "100px", textAlign: "center" }}
          onClick={() => toggle(0, '3')}
          style={{
            padding: "7px",
            width: "100%",
            textAlign: "center",
            maxHeight: "55px",

          }}
          className={activeTab === '3' ? 'jirango-active' : 'jirango-not-active'}
        >
          <SettingsIcon style={{
            fontSize: "1.2rem",
          }} />
          <div
            style={{

              fontWeight: "600",
              fontSize: "9px",
              marginTop: '2px',

              textTransform: "uppercase",
              borderBottom: "0px !important"
            }}
          >
            <SystemLabel name="AdvanceSettingsTab" />
          </div>
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export const TextCustomedTabGroup = ({ toggle, activeTab, tabName, email = false }) => {
  return (
    <Nav
      tabs
      style={{
        backgroundColor: "#fff",
        width: "100%",
        marginTop: '-14px',
        maxHeight: "55px"
      }}
    >
      <NavItem
        style={{
          width: "50%",
          maxHeight: "55px"
        }}
      >
        <NavLink
          onClick={() => toggle(0, '1')}
          style={{
            padding: "7px",
            width: "100%",
            textAlign: "center",
            maxHeight: "55px",
          }}
          className={activeTab === '1' ? 'jirango-active' : 'jirango-not-active'}
        >
          <PaletteIcon
            style={{
              fontSize: "1.4rem",
            }}
          />
          <div
            style={{
              fontWeight: "600",
              fontSize: "9px",
              marginTop: '2px',
              textTransform: "uppercase",
              borderBottom: "0px !important"
            }}
          >
            <SystemLabel name="StyleSettingsTab" />
          </div>
        </NavLink>
      </NavItem>
      <NavItem
        style={{
          maxHeight: "55px",
          width: "50%"
        }}
      >
        <NavLink
          onClick={() => toggle(0, '2')}
          style={{
            padding: "7px",
            width: "100%",
            maxHeight: "55px",
            textAlign: "center",
            marginTop: '2px',
          }}
          className={activeTab === '2' ? 'jirango-active' : 'jirango-not-active'}
        >
          <LabelIcon
            style={{
              fontSize: "1.4rem",
            }}
          />
          <div
            style={{
              fontWeight: "600",
              fontSize: "9px",
              textTransform: "uppercase",
              borderBottom: "0px !important"
            }}
          >
            <SystemLabel name="TagSettingsTab" />
          </div>
        </NavLink>
      </NavItem>
    </Nav>
  );
};


export const EditorTabGroup = ({ toggle, activeTab, tabName, tempIsInherited = null, email = false, isOwner = false }) => {
  return (
    <Nav
      tabs
      style={{
        backgroundColor: "#fff",
        width: "100%",
        maxHeight: "55px"
      }}
    >
      <NavItem
        style={{
          width: "50%",
          maxHeight: "55px"
        }}
      >
        <NavLink
          onClick={() => toggle("Elements")}
          style={{
            padding: "7px",
            width: "100%",
            textAlign: "center",
            maxHeight: "55px",
          }}
          className={activeTab === 'Elements' ? 'jirango-active' : 'jirango-not-active'}
        >
          <AppsIcon
            style={{
              fontSize: "1.2rem",
            }}
          />
          <div
            style={{
              fontWeight: "600",
              fontSize: "9px",
              marginTop: '2px',
              textTransform: "uppercase",
              borderBottom: "0px !important"
            }}
          >
            <SystemLabel name="ElementsSettingsTab" />
          </div>
        </NavLink>
      </NavItem>
      {email ?
        <NavItem
          style={{
            maxHeight: "55px",
            width: "50%"
          }}
        >
          <NavLink
            onClick={() => toggle("EmailSettings")}
            style={{
              padding: "7px",
              width: "100%",
              maxHeight: "55px",
              textAlign: "center",
              marginTop: '2px',
            }}
            className={activeTab === 'EmailSettings' ? 'jirango-active' : 'jirango-not-active'}
          >
            <EmailIcon
              style={{
                fontSize: "1.2rem",
              }}
            />
            <div
              style={{
                fontWeight: "600",
                fontSize: "9px",
                textTransform: "uppercase",
                borderBottom: "0px !important"
              }}
            >
              <SystemLabel name="EmailSettingsTab" />
            </div>
          </NavLink>
        </NavItem>
        : <NavItem
          style={{
            maxHeight: "55px",
            width: "50%"
          }}
        >
          <NavLink
            onClick={() => tempIsInherited !== false || isOwner ? toggle("TemplateSettings") : null}
            style={{
              padding: "7px",
              width: "100%",
              maxHeight: "55px",
              textAlign: "center",
              marginTop: '2px',
              position: 'relative'
            }}
            className={activeTab === 'TemplateSettings' ? 'jirango-active' : 'jirango-not-active'}
          >
            <InheritageWrapper status={!isOwner ? tempIsInherited : null} small={true} onClick={() => null} />
            <PaletteIcon
              style={{
                fontSize: "1.2rem",
              }}
            />
            <div
              style={{
                fontWeight: "600",
                fontSize: "9px",
                textTransform: "uppercase",
                borderBottom: "0px !important"
              }}
            >
              <SystemLabel name="TemplateSettingsTab" />
            </div>
          </NavLink>
        </NavItem>}
    </Nav>
  );
};
